import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { formatApiError } from "@/lib/api";

export const AuthCallback = () => {
  const { googleSession, setUser } = useAuth();
  const { setOpen } = useCart();
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const next = new URLSearchParams(location.search).get("next");
    googleSession(sessionId)
      .then((u) => {
        toast.success(`Welcome, ${u.name}`);
        nav(next === "checkout" ? "/shop" : u.role === "admin" ? "/admin" : "/", { replace: true });
        if (next === "checkout") setOpen(true);
      })
      .catch((e) => { setUser(false); toast.error(formatApiError(e)); nav("/login", { replace: true }); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div data-testid="auth-callback" className="min-h-[60vh]" />;
};
